// src/pages/Dashboard.jsx
import React, { useState, useRef, useEffect } from 'react';
import { Button } from 'primereact/button';
import { Chart } from 'primereact/chart';
import { Dropdown } from 'primereact/dropdown';
import { ProgressBar } from 'primereact/progressbar';
import { Avatar } from 'primereact/avatar';
import { Badge } from 'primereact/badge';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Carousel } from 'primereact/carousel';
import { Timeline } from 'primereact/timeline';
import { TabView, TabPanel } from 'primereact/tabview';


import Utils from "../utilities/Utils";
import SyncDashboard from '../components/SyncDashboard'; // NEW!

const Dashboard = () => {

    const [loading1, setLoading1] = useState(false);
    const [agendamentos, setAgendamento] = useState([]);
    const [usuariosTotal, setusuariosTotal] = useState(0);

    const iss = localStorage.getItem('iss');
    let roles = JSON.parse(localStorage.getItem('roles'));
    const companyId = roles.listAllAgendamentoByCompanyPrestador ? localStorage.getItem('idEmpresa') : null;
    const prestadorId = roles.listAllAgendamentoByPrestador ? localStorage.getItem('idPrestador') : null;

    useEffect(() => {
        // initAgendamento();
        // initPagamentos()
    }, []);

    return (
        <div className="layout-dashboard">
            <TabView>
                {/* NEW: TAB SINCRONIZAÇÃO */}
                <TabPanel header="Sincronização" leftIcon="pi pi-sync" className="mr-1">
                    <SyncDashboard />
                </TabPanel>
                {/* TABS: Usuários | Sincronização */}
                <TabPanel header="Usuários" leftIcon="pi pi-calendar">
                    <div className="grid">
                        <div className="col-12 md:col-4">
                            <div className="card widget-overview-box widget-overview-box-1">
                                <span className="overview-title">
                                    Usuários cadastrados
                                </span>
                                <div className="flex justify-content-between">
                                    <div className="overview-detail flex justify-content-between">
                                        <div className="overview-text">
                                            {usuariosTotal} <span className="overview-title">
                                                últimos 30 dias
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>


            </TabView>
        </div>
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(Dashboard, comparisonFn);